import { toast } from "react-toastify";
import { CalculateFinalPrice } from "../metadata/CalculatePrice";

export function GetWebBonus(services, masters, serviciosCatalogo) {
  try {
    if (!Array.isArray(services) || services.length === 0) return 0;

    return services.reduce((total, service) => {
        const finalPrice = CalculateFinalPrice(service, serviciosCatalogo);

        const rule = masters.find((r) =>
          r.category === "Web" &&
          r.rangeMin <= finalPrice &&
          (r.rangeMax === null || r.rangeMax >= finalPrice)
        );

        const percentageCommission = rule?.percentage
          ? (rule.percentage / 100) * finalPrice
          : 0;

        const fixed = Number(rule?.fixedCommission) || 0;
        const commission = fixed + percentageCommission;

        return total + commission;
      }, 0);
  } catch (e) {
    toast.error("Error calculando el bono de Web: " + e);
    return 0;
  }
}
